module.exports = __webpack_public_path__ + "img/shiminzhenz.0838e7ea.png";